import { render, staticRenderFns } from "./RecommendedDriver.vue?vue&type=template&id=a08e25b2&"
import script from "./RecommendedDriver.vue?vue&type=script&lang=js&"
export * from "./RecommendedDriver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports